// Note: The first file of a module here, must also register the module

import "./campaign-info-billing-users.component";
import "./campaign-info.component";
import "./change-password.component";
import "./consent.component";
import "./create-app-dialog.component";
import "./create-credit-card-modal.component";
import "./delete-campaign-dialog.component";
import "./edit-campaign-dialog.component";
import "./edit-profile.component";
import "./essentials-dialog.component";
import "./feature-settings-dialog.component";
import "./image-crop-dialog.component";
import "./leave-campaign-survey.component";
import "./plan-details-card.component";
import "./plan-details-content.component";
import "./plan-details-page.component";
import "./profile.component";
import "./view-invoice.component";
